import VueRouter from 'vue-router'
import store from '@/store'
// import Order from '@/views/order/index.vue'
import Main from '@/views/main.vue'
import Vue from "vue";

Vue.use(VueRouter)

const menuRoot = {
  path: '/home',
  component: Main,
  name: 'home'
}

// 静态路由配置
const commonRoutes = [
  {
    path: '/login',
    name: 'login-index',
    meta:{
      title:'登录'
    },
    component: resolve => {
      require(['@/views/login/index.vue'], resolve)
    }
  },
  {
    path: '/design',
    name: 'design-index',
    component: resolve => {
      require(['@/views/design/index.vue'], resolve)
    }
  },
]

const router = new VueRouter({routes: commonRoutes});

// 添加路由
export function addRouter(params) {
  router.matcher = new VueRouter({routes: commonRoutes}).matcher // reset router

  //添加新增的路由
  router.options.routes.push(params);
  router.addRoute(params);
}
// 清空路由
export function clearRouter() {
  router.matcher = new VueRouter({routes: commonRoutes}).matcher // reset router
  router.options.routes.pop();
}

function generateRoutesFromMenus(menus) {
  const routes = []
  menus.forEach(item => {
    const menu = item.element
    const route = {
      name: menu.menuName,
      meta: {
        title: menu.menuName,
        authKey: menu.menuId
      }
    }

    if (menu.target) {
      route.path = menu.target;
    } else {
      route.path = '/';
    }
    if (menu.url) {
      route.component = () => import(`../views//${menu.url}`)
    }

    if (item.children) {
      route.children = generateRoutesFromMenus(item.children)
    }
    routes.push(route)
  })
  return routes
}


export async function createMenuRouter(menus){
  return new Promise((resolve)=>{
    const menuRouters={...menuRoot}
    menuRouters.children = generateRoutesFromMenus(menus)
    addRouter(menuRouters)
    resolve();
  })
}
export async function clearMenuRouter(){
  return new Promise((resolve)=>{
    clearRouter()
    resolve();
  })
}

function getAuth(){
  const userInfo = store.getters.userInfo;
  const auth = userInfo.userName
  if (auth) return auth
  else return false
}

router.beforeEach((to, from, next) => {
  const auth = getAuth()
  // console.log('route link', auth, from.name, to.name)
  if (to.path === '/') {
    // 空路径跳转到首页
    next('/home')
  } else if (to.path === '/login') {
    // 未登录直接跳转登录页
    next()
  } else if (!auth) {
    next('/login')
  } else {
    let menuRouterIsExist = false, item = router.options.routes;
    for (let index in item) {
      if (item[index].name === 'home') {
        menuRouterIsExist = true;
        break;
      }
    }

    //如果Cookie中有新增的路由
    if (!menuRouterIsExist) {
      //重新载入新增的路由
      createMenuRouter(store.getters.menus).then(()=>{
        //载入成功，替换页面，放行
        next({...to, replace:true});
      }).catch(()=>{
        //载入失败
        next('/login');
      });
    } else {
      //有新增的路由，放行
      next();
    }
  }
})

router.afterEach((to) => {
  let docTitle = '';
  if (to.meta.title) {
    docTitle = to.meta.title + ' - ' //修改网页的title
  }
  document.title = docTitle + '微大使管理系统';
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js